import { useSelector } from 'react-redux'
import type { ProviderFeatureName, UserRoleName } from 'src/generated'
import { userRoleSelector } from 'src/redux/providers/selectors'

// ----------------------------------------------------------------------
// Who may open Return areas.
//
// A fleet's admin and fleet manager draw and change their own fleet's areas,
// once Beast has switched freestyle on with them; Beast staff pass both gates
// and change every area. A fleet assistant is not offered the page. The server
// holds the same rule on every field (`returnAreaRoles.contract.test.ts`), so
// this decides only what the console offers. See docs/RETURN_AREAS.md.
// ----------------------------------------------------------------------

/** Spread into a menu entry's `roles` and a route's `requiredRole`. */
export const RETURN_AREA_ROLES: readonly UserRoleName[] = [
  'admin',
  'fleetManager',
]

/** The provider feature a fleet needs before the page is offered. */
export const RETURN_AREA_FEATURE: ProviderFeatureName = 'freestyleEnabled'

/** Whether this viewer is Beast staff, who see owners and hand areas over. */
export const useReturnAreasStaff = (): boolean =>
  useSelector(userRoleSelector) === 'superAdmin'
